module.exports = new __parcel__URL__("adult-swim-logo.7d752434.png").toString();